export enum LoggerFields {
  Log = "log",
  Verbose = "verbose",
  Information = "information",
  Warning = "warning",
  Error = "error",
  Critical = "critical",
  Group = "group",
  GroupEnd = "groupEnd",
}

export interface Logger {
  [LoggerFields.Log]: (msg: unknown, params?: unknown) => void;
  [LoggerFields.Verbose]: (name: string) => void;
  [LoggerFields.Information]: (message: string) => void;
  [LoggerFields.Warning]: (error: string) => void;
  [LoggerFields.Error]: (error: string) => void;
  [LoggerFields.Critical]: (error: string, params?: unknown) => void;
  [LoggerFields.Group]: (name: string, params?: unknown) => void;
  [LoggerFields.GroupEnd]: () => void;
}
